import { useState, useEffect } from 'react';

/**
 * Returns responsive breakpoint booleans based on current window width.
 * isMobile  — true when width < 640px  (phones: 375px–639px)
 * isTablet  — true when width < 1024px (tablets: 640px–1023px)
 *
 * Usage:
 *   const { isMobile, isTablet } = useWindowWidth();
 */
export default function useWindowWidth() {
  const [width, setWidth] = useState(
    () => typeof window !== 'undefined' ? window.innerWidth : 1024
  );

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {
    isMobile: width < 640,
    isTablet: width < 1024,
    width,
  };
}
